import { editorData } from './EditorStore';

export const updateEditorData = (value) => editorData.update((oldValue) => value);
